<span class="rounded-full text-[8px] md:text-xs px-2 py-1 md:py-1.5 md:px-3 leading-tight relative md:bottom-0.5 whitespace-nowrap text-amber-500 border-amber-500 border-[1px]">
    Not Yet Completed
</span>
